import { render, staticRenderFns } from "./HostTemplate.vue?vue&type=template&id=2e877ecd&scoped=true"
import script from "./HostTemplate.vue?vue&type=script&lang=js"
export * from "./HostTemplate.vue?vue&type=script&lang=js"
import style0 from "./HostTemplate.vue?vue&type=style&index=0&id=2e877ecd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e877ecd",
  null
  
)

export default component.exports